module.exports = __webpack_public_path__ + "static/contactus-bg-0b7a1cb0e4aee66754f0bef957d28bab.jpg";